import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const AMBASSADOR_TOKEN_KEY = 'eg_ambassador_token';

export default function AmbassadorJoin() {
  const { token } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (token && !localStorage.getItem(AMBASSADOR_TOKEN_KEY)) {
      localStorage.setItem(AMBASSADOR_TOKEN_KEY, token);
    }
    navigate('/public-square', { replace: true });
  }, [token, navigate]);

  return null;
}
